import type { SupabaseClient } from "@supabase/supabase-js";

import { isMissingDeletedAtColumnError } from "@/lib/medicationDeletedAtFallback";

const HISTORY_SELECT =
  "id,name,dosage,quantity,unit,expiry_month,expiry_year,price_per_box,status,scan_date,created_at";

/**
 * Loads medication rows for the History page. Prefer filtering `deleted_at IS NULL` when the
 * column exists (soft deletes). If production DBs lag migrations and the column is missing,
 * retries without that filter so the page still works — all rows are then treated as active.
 */
export async function fetchMedicationsForHistory(sb: SupabaseClient, userId: string) {
  const base = () =>
    sb
      .from("medications")
      .select(HISTORY_SELECT)
      .eq("user_id", userId)
      .order("scan_date", { ascending: false, nullsFirst: false })
      .order("created_at", { ascending: false });

  let result = await base().is("deleted_at", null);

  if (result.error && isMissingDeletedAtColumnError(result.error)) {
    result = await base();
  }

  return result;
}
